export default {
  projects: 'MAIN_PROJECTS',
  news: 'MAIN_NEWS'
};
